import axios from "axios";
import { useState, useEffect } from "react";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import {
    QUALIFICATION_LOADING,
    QUALIFICATION_SUCCESS,
    QUALIFICATION_FAILED,
  } from "../Constants/qualificationConstants";

export const getQualification = () => async (dispatch) => {
  //  const [data, setData] = useState([]);
  try {

    dispatch({ type: QUALIFICATION_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

   

    const requestData = {
        token : userLocalData.id,
        param:"qualification"
    }

    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + "/GenericApi/masterData",
    requestData,
    {
      headers: headers,
    });
     
     if (data.status === "success") {

    dispatch({
      type: QUALIFICATION_SUCCESS,
      payload: data,
    });

  }
  let optionsFormat = [];

  console.log(typeof data.data);

  Object.entries(data.data).forEach((element, index) => {
    const [key, value] = element;
    optionsFormat.push({
      value: key,
      label: value
    });
  });


  localStorage.setItem("qualification", JSON.stringify(optionsFormat));
//   setData(optionsFormat);
  console.log("sas",optionsFormat);


  } catch (error) {
    dispatch({
      type: QUALIFICATION_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
  }
};